<template>
  <div>
    <el-table :data="goodsAry"
              border default-expand-all
              style="width: 100%;margin-top: 20px"
              :header-cell-style="rowClass">
      <el-table-column label="任务基本信息" min-width="100%" header-align="left">
        <el-table-column label="商品信息" min-width="70%" align="center">
          <el-table-column align="center" min-width="20%">
            <template slot-scope="scope">
              <el-image :src="scope.row.goodImageUrl"></el-image>
            </template>
          </el-table-column>
          <el-table-column align="left" min-width="50%">
            <template slot-scope="scope">
              <span>{{ scope.row.goodTitle }}</span>
              <div>
                <a :href="scope.row.goodUrl" target="_blank">{{ scope.row.goodUrl }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" min-width="5%">
          <template slot-scope="scope">
            <span>{{scope.row.mainGood!=null&&scope.row.mainGood?"主宝贝":"副宝贝"}}</span>
          </template>
        </el-table-column>
        <el-table-column label="拍下单价" prop="goodPrice" min-width="15%" align="center"></el-table-column>
        <el-table-column label="每单拍下数量" prop="goodNum" min-width="15%" align="center"></el-table-column>
      </el-table-column>
    </el-table>
    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;border-top: 0px;"
              :show-header="false">
      <el-table-column prop="taskTypeString" min-width="100%">
        <template slot-scope="scope">
          <span>任务类型:&nbsp&nbsp</span>
          <span v-html="scope.row.taskTypeString"></span>
          <span style='color: #04befe; margin: 10px;'>
            <span v-if='scope.row.baseMoneyReturnType'>商返</span>
            <span v-else>平台</span>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;border-top: 0px;"
              :show-header="false">
      <el-table-column prop="goodsInfo" min-width="100%">
        <template slot-scope="scope">
          <span>商品信息:展示价&nbsp&nbsp{{ scope.row.goodsInfo }}&nbsp&nbsp(元)</span>
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}">
      <el-table-column label="普通任务:搜索关键词及单数" min-width="100%" header-align="left"
                       v-if="tableFeildAndVal.taskChecked">
        <template slot-scope="scope">
          <div v-for="(item, index) in getSomeTaks"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="8">
                <span v-if="isQrcodeTask">下单关键词: &nbsp&nbsp<span style="color: coral">{{ tableFeildAndVal.qrcodeTaskImgUrl}}</span></span>
                <span v-else>下单关键词: &nbsp&nbsp<span style="color: coral">{{ item.orderKeys }}</span></span>
              </el-col>
              <el-col :span="8">
                <span>备用关键词: &nbsp&nbsp{{ item.orderBackKey }}</span>
              </el-col>
              <el-col :span="8">
                <span>任务单数: &nbsp&nbsp<span style="color: coral">{{ item.orderAdd }}</span></span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="文字好评任务:搜索关键词及单数" min-width="100%" header-align="left"
                       v-if="tableFeildAndVal.textChecked">
        <template slot-scope="scope">
          <div v-for="(item, index) in getSomeTaks"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="8">
                <span v-if="isQrcodeTask">下单关键词: &nbsp&nbsp<span style="color: coral">{{ tableFeildAndVal.qrcodeTaskImgUrl}}</span></span>
                <span v-else>下单关键词: &nbsp&nbsp<span style="color: coral">{{ item.orderKeys }}</span></span>
              </el-col>
              <el-col :span="8">
                <span>备用关键词: &nbsp&nbsp{{ item.orderBackKey }}</span>
              </el-col>
              <el-col :span="8">
                <span>任务单数: &nbsp&nbsp<span style="color: coral">{{ item.orderAdd }}</span></span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            <div v-for="(textItem, indx) in getReivewContent(item)" :key="indx">
              <el-row>
                <el-col :span="24">
                  <span>指定评论内容:&nbsp&nbsp<span style="color: red;">{{ textItem.reviewContent }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row>
                <el-col :span="24">
                  <span>指定颜色尺寸:&nbsp&nbsp<span style="color: red;">{{ textItem.orderColorSize }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图文好评任务:搜索关键词及单数" min-width="100%" header-align="left"
                       v-if="tableFeildAndVal.imageChecked">
        <template slot-scope="scope">
          <div v-for="(item, index) in getSomeTaks"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="8">
                <span v-if="isQrcodeTask">下单关键词: &nbsp&nbsp<span style="color: coral">{{ tableFeildAndVal.qrcodeTaskImgUrl}}</span></span>
                <span v-else>下单关键词: &nbsp&nbsp<span style="color: coral">{{ item.orderKeys }}</span></span>
              </el-col>
              <el-col :span="8">
                <span>备用关键词: &nbsp&nbsp{{ item.orderBackKey }}</span>
              </el-col>
              <el-col :span="8">
                <span>任务单数: &nbsp&nbsp<span style="color: coral">{{ item.orderAdd }}</span></span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            <div v-for="(imgItem, indx) in getReivewContent(item)" :key="indx">
              <el-row>
                <el-col :span="24">
                  <span>指定评论内容:&nbsp&nbsp<span style="color: red;">{{ imgItem.reviewContent }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row>
                <el-col :span="24">
                  <span>指定颜色尺寸:&nbsp&nbsp<span style="color: red;">{{ imgItem.orderColorSize }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row :gutter="2" align="middle">
                <el-col v-for="(subImg, indx) in imgItem.imageUrls" :key="indx" :span="24/imgItem.imageUrls.length">
                  <el-image style="width: 120px; height: 120px;" :src="subImg" :preview-src-list="imgItem.imageUrls"></el-image>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="视频好评任务:搜索关键词及单数" min-width="100%" header-align="left"
                       v-if="tableFeildAndVal.videoChecked">
        <template slot-scope="scope">
          <div v-for="(item, index) in getSomeTaks"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="8">
                <span v-if="isQrcodeTask">下单关键词: &nbsp&nbsp<span style="color: coral">{{ tableFeildAndVal.qrcodeTaskImgUrl}}</span></span>
                <span v-else>下单关键词: &nbsp&nbsp<span style="color: coral">{{ item.orderKeys }}</span></span>
              </el-col>
              <el-col :span="8">
                <span>备用关键词: &nbsp&nbsp{{ item.orderBackKey }}</span>
              </el-col>
              <el-col :span="8">
                <span>任务单数: &nbsp&nbsp<span style="color: coral">{{ item.orderAdd }}</span></span>
              </el-col>
            </el-row>
            <div v-for="(videoItem, indx) in getReivewContent(item)" :key="indx">
              <el-row>
                <el-col :span="24">
                  <span>指定评论内容:&nbsp&nbsp<span style="color: red;">{{ videoItem.reviewContent }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row>
                <el-col :span="24">
                  <span>指定颜色尺寸:&nbsp&nbsp<span style="color: red;">{{ videoItem.orderColorSize }}</span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row>
                <el-col :span="24">
                  <span>指定视频:&nbsp&nbsp<span style="color: red;">
                    <video width="260" height="200" controls autoplay>
                       <source :src="findVideoUrl(videoItem.videoUrls)" type="video/mp4">
                    </video>
                  </span></span>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
              <el-row :gutter="2" align="middle" style="width: 60%;">
                <el-col v-for="(subImg, indx1) in findImgsUrl(videoItem.videoUrls)" :key="indx1" :span="24/(videoItem.videoUrls.length-1)">
                  <el-image style="width: 120px; height: 120px;" :src="subImg" :preview-src-list="findImgsUrl(videoItem.videoUrls)"></el-image>
                </el-col>
              </el-row>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            </div>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}" v-if="timePlan">
      <el-table-column label="放单计划设置" min-width="100%" header-align="left">
        <template slot-scope="scope">
          <div v-for="(itm, index) in scope.row.orderPlan"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="8">
                <span>放单计划:&nbsp&nbsp 从<span style="color: coral;margin: 1rem;">{{ itm.orderPlanTime }}</span>开始，</span>
              </el-col>
              <el-col :span="4">
                <span>每隔:&nbsp&nbsp <span style="color: coral;margin: 1rem;">{{ itm.spaceMinute }}</span>分钟</span>
              </el-col>
              <el-col :span="6">
                <span>放出: &nbsp&nbsp<span style="color: coral;margin: 1rem;">{{ itm.oplanNum }}</span>单，</span>
              </el-col>
              <el-col :span="6">
                <span>共放: &nbsp&nbsp<span style="color: coral;margin: 1rem;">{{ itm.oplanTotal }}</span>单</span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}" v-else>
      <el-table-column label="放单计划设置" min-width="100%" header-align="left">
        <template slot-scope="scope">
          <el-row :gutter="2">
            <el-col :span="23" style="margin: 10px">
              <div>放单计划:&nbsp&nbsp 从<span style="color: coral;margin: 1rem;">{{ scope.row.planStartTime }}</span>开始:
              </div>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            </el-col>
          </el-row>
          <div v-for="(itm, index) in scope.row.detail"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="4">
                <span>时间:&nbsp&nbsp <span style="color: coral;margin: 1rem;">{{ itm.hour }}</span>点</span>
              </el-col>
              <el-col :span="6">
                <span>放出: &nbsp&nbsp<span style="color: coral;margin: 1rem;">{{ itm.orderNum }}</span>单，</span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
          <el-row>
            <el-col :span="23" style="margin: 10px; text-align: right;">
              <div>共放: &nbsp&nbsp<span style="color: coral;margin: 1rem;">{{ scope.row.detail.length }}</span>单</div>
              <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <!-- 隔天单的时间显示-->
    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}"
              v-show="isAfterDayOrder">
    <el-table-column label="隔天任务的时间" min-width="100%" header-align="left" >
      <template slot-scope="scope">
        <el-row :gutter="2">
          <el-col :span="23" style="margin: 10px">
            <div>任务开始时间:&nbsp&nbsp <span style="color: coral;margin: 1rem;">{{ scope.row.buyBeginTime}}</span>
            </div>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
            <div>任务结束时间:&nbsp&nbsp <span style="color: coral;margin: 1rem;">{{ scope.row.buyEndTime}}</span>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-table-column>
    </el-table>
    <!-- end -->

    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}">
      <el-table-column label="接单用户淘宝账号属性限制" min-width="100%" header-align="left">
        <template slot-scope="scope">
          <div v-for="(itm1, index) in scope.row.orderAccountLimit"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="12">
                <span>{{ itm1.name }}:&nbsp&nbsp 是
                  <span style="color: coral;margin: 1rem;" v-if="findKeyWithObj(itm1)!=null">{{ getSubServiceAttach(itm1, findKeyWithObj(itm1)) }}</span>
                  <span style="color: coral;" v-if="itm1.name == '地域限制'">
                    <span>{{getLocalInfosChecked}},</span>
                  </span>
                </span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="tableData"
              border default-expand-all
              style="width: 100%;margin-top: 20px; pointer-events: none"
              :header-cell-style="{background:'#F5F5F5'}">
      <el-table-column label="商家附加要求" min-width="100%" header-align="left">
        <template slot-scope="scope">
          <div v-for="(itm2, index) in scope.row.shopAttachNeed"
               :key="index"
               style="margin: 10px">
            <el-row :gutter="2">
              <el-col :span="12">
                <span>{{ itm2.keys }}:&nbsp&nbsp <span
                    style="color: coral;margin: 1rem;width: 100%;text-align: center;">{{ itm2.values }}</span></span>
              </el-col>
            </el-row>
            <hr style=" height:1px;border:none;border-top:1px dotted darkgray;"/>
          </div>
          <el-row :gutter="2" v-if="scope.row.shopAttachImage.length > 0">
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <span>商家备注图片</span>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8" v-for="(i,idx) in scope.row.shopAttachImage" :key="idx">
                  <el-image :src="i" style="width: 180px; height: 180px;"></el-image>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {serviceAttach} from "../../lib/dictToChness";
import {isObjectEmpty, isStrEmpty} from "@/lib/utils";

export default {
  name: "TaskDetailComponent",
  props: ["tableFeildAndVal"],
  mixins: [MixinCUD],
  data() {
    return {
      goodsAry: null,
      tableData: [
        /*{

         sameTask:[
           {
             orderKey: "小米电话儿童手表",
             backKey: "",
             taskOrderNum: 1
           },
           {
             orderKey: "华为智能手表",
             backKey: "",
             taskOrderNum: 1
           },
           {
             orderKey: "小米儿童手表",
             backKey: "",
             taskOrderNum: 1
           }
         ],
         orderPlan:[
           {
             dateTime: "2021/6/16 12:00:00",
             spaceTime: "5",
             orderNum: 1,
             orderTotal: 1
           },
           {
             dateTime: "2021/6/16 14:00:00",
             spaceTime: "5",
             orderNum: 1,
             orderTotal: 1
           },
           {
             dateTime: "2021/6/16 17:00:00",
             spaceTime: "5",
             orderNum: 1,
             orderTotal: 1
           }
         ],
         orderAccountLimit:[
           {
             keys: "允许使用优惠券及红包",
             values: "是"
           },
           {
             keys: "需要假聊",
             values: "是"
           },
           {
             keys: "货比足迹",
             values: "是"
           },
           {
             keys: "浏览目标宝贝",
             values: "是"
           },
           {
             keys: "核对商品链接",
             values: "是"
           }
         ],
         shopAttachNeed:[
           {
             keys: "商家备注内容",
             values: "下单升级版，麻烦货比三家，收藏加购，搜不到的注意空格，谢谢了 "
           }
         ]

          },

         */
      ],
      timePlan: true
    }
  },
  mounted() {
    //console.log(this.tableFeildAndVal);
    this.timePlan = (this.tableFeildAndVal.orderPlanAry != null && this.tableFeildAndVal.orderPlanAry.length > 0) ? true : false;
    this.buildTableData();
  },
  computed: {
    isAfterDayOrder(){
      return this.tableFeildAndVal.b2cTaskType.id == 3;
    },
    isQrcodeTask(){
      return this.tableFeildAndVal.b2cTaskType.id == 11 || this.tableFeildAndVal.b2cTaskType.id == 12;
    },
    getLocalInfosChecked(){
      //console.log(this.tableFeildAndVal.serviceAttarchBeanArray)
      let stringTmp = this.tableFeildAndVal.serviceAttarchBeanArray["localLimitReview"] == 0?"可接单地区":"不可接单地区";
      return stringTmp+"："+this.tableFeildAndVal.serviceAttarchBeanArray["localInfosChecked"];
    },
    getSubServiceAttach(){
      return function (obj, key){
      let subKey = this.tableFeildAndVal.serviceAttarchBeanArray[key]
      let  tmp = obj[key][subKey];
      return tmp;
    }},
    getSomeTaks() {
      if (this.tableFeildAndVal.taskChecked) {
        return this.tableFeildAndVal.taskAry;
      } else if (this.tableFeildAndVal.textChecked) {
        return this.tableFeildAndVal.textAry;
      } else if (this.tableFeildAndVal.imageChecked) {
        return this.tableFeildAndVal.imageAry
      } else {
        return this.tableFeildAndVal.videoAry;
      }
    },
    getReivewContent(){
      return function (item) {
        //console.log(item)
        if (this.tableFeildAndVal.textChecked) {
          if (!isObjectEmpty(this.tableFeildAndVal.textContentAryMap)){
            return this.tableFeildAndVal.textContentAryMap[item.id];
          }
        } else if (this.tableFeildAndVal.imageChecked) {
          if (!isObjectEmpty(this.tableFeildAndVal.imageContentAryMap)) {
            return this.tableFeildAndVal.imageContentAryMap[item.id];
          }
        } else if (this.tableFeildAndVal.videoChecked)  {
          if (!isObjectEmpty(this.tableFeildAndVal.videoContentAryMap)) {
            return this.tableFeildAndVal.videoContentAryMap[item.id];
          }
        }
      }
    },
    findVideoUrl(){
      return function (videUrls) {
        for (let item of videUrls){
          if (this.checkFile(item, 'video')){
            return item;
          }
        }
        return null;
      }
    },
    findImgsUrl(){
      return function (imgUrls) {
        return imgUrls.filter(item=>this.checkFile(item, 'image'));
      }
    }
  },
  methods: {
    checkFile(fileValue,type) {
       console.log("fileValue==" + fileValue);
       let index = fileValue.indexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
       let  fileValueSuffix = fileValue.substring(index); //截断"."之前的，得到后缀
       if(type == 'video') {
           if (!/(.*)\.(mp4|rmvb|avi|ts)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合视频格式
          return false;
        }
       }
       if(type == 'image') {
        if (!/(.*)\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合图片格式
             return false;
         }
       }

        return true;
    },
    findKeyWithObj(jsonObj){
      return Object.keys(jsonObj).filter(item => !item.includes("name")).pop();
    },
    getServiceAttachLimit(){
      let tmpArray = new Array();
      for (let key in this.tableFeildAndVal.serviceAttarchBeanArray) {
        if (key.includes("Checked")
            && serviceAttach[key] != null && "localInfosChecked" != key){
          tmpArray.push(serviceAttach[key]);
        }
      }

      return tmpArray;
    },
    getServiceAttach() {
      let tmpArray = new Array();
      for (let key in this.tableFeildAndVal.serviceAttarchBeanArray) {
        console.log(key)
        if (serviceAttach[key] == null) {
          continue;
        }
        let keys = Object.keys(serviceAttach[key]);
        //console.log(keys)
        if (keys.includes(key.replace("Checked", ""))
            || keys.includes("customeVerifyReview")) {
          for (let subKey in keys) {
            //console.log(keys[subKey])
            if (keys[subKey] != "name") {
              //console.log(serviceAttach[key], serviceAttach[key][keys[subKey]])
              let Indx = 0;
              if (Object.keys(this.tableFeildAndVal.serviceAttarchBeanArray).includes(keys[subKey])) {
                Indx = 1;
              }
              tmpArray.push({keys: serviceAttach[key].name, values: serviceAttach[key][keys[subKey]][Indx]});
            }
          }
        } else {
          tmpArray.push({keys: serviceAttach[key].name, values: "是"});
        }
      }
      console.log(tmpArray)
      return tmpArray;
    },
    getShopAttachNeed() {
      let tmpArray = new Array();
      if (this.tableFeildAndVal.remarksContent.replace(/(^\s*)|(\s*$)/g, "") != "") {
        tmpArray.push({keys: "商家备注内容", values: this.tableFeildAndVal.remarksContent});
      }
      return tmpArray;
    },
    getShopAttachImage() {
      let ImageArray = new Array();
      if (!isStrEmpty(this.tableFeildAndVal.firstImageUrl)) {
        ImageArray.push(this.tableFeildAndVal.firstImageUrl);
      }
      if (!isStrEmpty(this.tableFeildAndVal.secondImageUrl)) {
        ImageArray.push(this.tableFeildAndVal.secondImageUrl);
      }
      if (!isStrEmpty(this.tableFeildAndVal.thirdImageUrl)) {
        ImageArray.push(this.tableFeildAndVal.thirdImageUrl);
      }

      return ImageArray;
    },
    buildTableData() {
      let tmpData = {
        taskTypeString: "<span style='color: coral; margin: 10px;'>" + this.tableFeildAndVal.b2cTaskType.taskName + "</span> <span style='color: #04befe; margin: 10px;'>" + this.tableFeildAndVal.returnMoneyType + "</span> ",
        goodsInfo: this.tableFeildAndVal.sreachPrice,
        sameTask: this.tableFeildAndVal.taskAry,
        orderPlan: this.tableFeildAndVal.orderPlanAry,
        detail: this.tableFeildAndVal.detail,
        planStartTime: this.tableFeildAndVal.planStartTime,
        taskTypeId: this.tableFeildAndVal.b2cTaskType.id,
        buyBeginTime: this.tableFeildAndVal.buyBeginTime,
        buyEndTime: this.tableFeildAndVal.buyEndTime,
        orderAccountLimit: this.getServiceAttachLimit(),
        shopAttachNeed: this.getShopAttachNeed(),
        shopAttachImage: this.getShopAttachImage(),
        baseMoneyReturnType: this.tableFeildAndVal.baseMoneyReturnType
      };
      this.tableData.push(tmpData);
      this.goodsAry = this.tableFeildAndVal.goodsAry;
    },
    rowClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex == 2 && (columnIndex == 0 || columnIndex == 1)) {
        return {display: 'none'}
      }
    }
  }
}
</script>

<style scoped>
.el-image {
  max-height: 200px;
  max-width: 180px;
}
</style>
